// src/basketStorage.ts
var BASKET_STORAGE_KEY = "basket";
var getBasketFromLocalStorage = () => {
  const basket = localStorage.getItem(BASKET_STORAGE_KEY);
  return basket ? JSON.parse(basket) : {};
};
var saveBasketToLocalStorage = (basket) => {
  localStorage.setItem(BASKET_STORAGE_KEY, JSON.stringify(basket));
};

export {
  getBasketFromLocalStorage,
  saveBasketToLocalStorage
};
